import { ROLE_PERMISSION_MAPPING, TEAM_PERMISSION } from "./enums";

export function hasPermission(memberRole: string | number, permission: TEAM_PERMISSION) {
  const memberPermissions = ROLE_PERMISSION_MAPPING[memberRole];
  return memberPermissions?.includes(permission) ?? false;
}
